import React, { useEffect, useState } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { Card, Col, Image, Row, SimpleCollapse, Span } from 'components'
import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useAuth, useLoading, useModal, useReportPrint } from 'hooks'
import {
  IHandlePrintConsolidacaoEfetivo,
  IRelatorioHntHeContent
} from 'hooks/useReportPrint/types'
import {
  ReportsConsolidationServices,
  IConsolidacaoTableEntity
} from 'services/NGT/EffectiveConsolidation'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import { downloadURI } from '../../EffectiveConsolidation'
import { ReportTable } from './components/ReportTable/ReportTable'

interface ICollapsesPropsPDF {
  collapseTitle: string
  tableTitle: string
}

interface IReportHntHe {
  flRecorrente: boolean
}

const ReportHntHe: React.FC<IReportHntHe> = ({ flRecorrente }) => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const { handlePrintHntHe } = useReportPrint()
  const { user } = useAuth()

  const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear())

  const [isGeneratePDF] = useState<boolean>(false)
  const [reportHntHeByArea, setReportHntHeByArea] =
    useState<IConsolidacaoTableEntity>()
  const [reportHntHeByCompany, setReportHntHeByCompany] =
    useState<IConsolidacaoTableEntity>()
  const [reportHntHeByExecutive, setReportHntHeByExecutive] =
    useState<IConsolidacaoTableEntity>()
  const [reportHntHeByUnit, setReportHntHeByUnit] =
    useState<IConsolidacaoTableEntity>()

  const collapsesTitles: ICollapsesPropsPDF[] = [
    {
      collapseTitle: 'Distribuição por Diretoria Executiva',
      tableTitle: 'Diretoria Executiva'
    },
    {
      collapseTitle: 'Distribuição por Empresas',
      tableTitle: 'Empresa'
    },
    {
      collapseTitle: 'Distribuição por Área',
      tableTitle: 'Área'
    },
    {
      collapseTitle: 'Distribuição por Unidade de Negócio',
      tableTitle: 'Unidade Negócio'
    }
  ]

  const GenerateExcelHntHe = async () => {
    setLoading('loading')

    ReportsConsolidationServices()
      .GetExcelHNomaisxHExtras(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )
      .then((response) => {
        if (response.status === 200) {
          downloadURI(response.data, `Relatorio-Hnt-He.xlsx`)
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ||
            error.message ||
            'Não foi possivel fazer o download da planilha, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClickPdfReport = async () => {
    setLoading('loading')

    try {
      setLoading('idle')

      const pdfDataArray: IRelatorioHntHeContent[] = []

      collapsesTitles.forEach((collapseTitle) => {
        pdfDataArray.push({
          anoAnterior: currentYear - 1,
          anoAtual: currentYear,
          body:
            collapseTitle.collapseTitle ===
              'Distribuição por Diretoria Executiva'
              ? reportHntHeByExecutive?.items.map((item, index) => {
                const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                // Criando as listas principais
                effectiveByExecutiveArray.push([
                  item?.nmGrupoConsolidacao.toUpperCase(),
                  item?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                    'pt-br'
                  ),
                  item?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                    'pt-br'
                  )
                ])
                // Adicionando as listas de subItens
                item.unidadeGestoraInfo.forEach((subItem) =>
                  effectiveByExecutiveArray.push([
                    FORMAT.capitalizeString(
                      subItem?.nmUnidadeGestora.toLowerCase()
                    ),
                    subItem?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    subItem?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    )
                  ]),
                ),
                  !reportHntHeByExecutive.items[index + 1] && effectiveByExecutiveArray.push([
                    "Total",
                    reportHntHeByExecutive?.total[0]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[0]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[1]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[1]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[2]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[2]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[3]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[3]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[4]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[4]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[5]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[5]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[6]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[6]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[7]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[7]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[8]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[8]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[9]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[9]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[10]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[10]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[11]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[11]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[12]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    reportHntHeByExecutive?.total[12]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                  ])
                return effectiveByExecutiveArray
              })
              : collapseTitle.collapseTitle === 'Distribuição por Empresas'
                ? reportHntHeByCompany?.items.map((item, index) => {
                  const effectiveByCompanyArray: (string | number)[][] = [] // Array auxiliar
                  // Criando as listas principais
                  effectiveByCompanyArray.push([
                    item?.nmGrupoConsolidacao.toUpperCase(),
                    item?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                      'pt-br'
                    ),
                    item?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                      'pt-br'
                    )
                  ])
                  // Adicionando as listas de subItens
                  item.unidadeGestoraInfo.forEach((subItem) =>
                    effectiveByCompanyArray.push([
                      FORMAT.capitalizeString(
                        subItem?.nmUnidadeGestora.toLowerCase()
                      ),
                      subItem?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      subItem?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      )
                    ])
                  ),
                    !reportHntHeByCompany.items[index + 1] && effectiveByCompanyArray.push([
                      "Total",
                      reportHntHeByCompany?.total[0]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[0]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[1]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[1]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[2]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[2]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[3]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[3]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[4]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[4]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[5]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[5]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[6]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[6]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[7]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[7]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[8]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[8]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[9]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[9]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[10]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[10]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[11]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[11]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[12]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      reportHntHeByCompany?.total[12]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                    ])

                  return effectiveByCompanyArray
                })
                : collapseTitle.collapseTitle === 'Distribuição por Área'
                  ? reportHntHeByArea?.items.map((item, index) => {
                    const effectiveByAreaArray: (string | number)[][] = [] // Array auxiliar
                    // Criando as listas principais
                    effectiveByAreaArray.push([
                      item?.nmGrupoConsolidacao.toUpperCase(),
                      item?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                        'pt-br'
                      ),
                      item?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                        'pt-br'
                      )
                    ])
                    // Adicionando as listas de subItens
                    item.unidadeGestoraInfo.forEach((subItem) =>
                      effectiveByAreaArray.push([
                        FORMAT.capitalizeString(
                          subItem?.nmUnidadeGestora.toLowerCase()
                        ),
                        subItem?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        subItem?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        )
                      ])
                    ),
                      !reportHntHeByArea.items[index + 1] && effectiveByAreaArray.push([
                        "Total",
                        reportHntHeByArea?.total[0]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[0]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[1]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[1]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[2]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[2]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[3]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[3]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[4]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[4]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[5]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[5]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[6]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[6]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[7]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[7]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[8]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[8]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[9]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[9]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[10]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[10]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[11]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[11]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[12]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByArea?.total[12]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                      ])
                    return effectiveByAreaArray
                  })
                  : collapseTitle.collapseTitle ===
                    'Distribuição por Unidade de Negócio'
                    ? reportHntHeByUnit?.items.map((item, index) => {
                      const effectiveByUnityArray: (string | number)[][] = [] // Array auxiliar
                      // Criando as listas principais
                      effectiveByUnityArray.push([
                        item?.nmGrupoConsolidacao.toUpperCase(),
                        item?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        item?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        )
                      ])
                      // Adicionando as listas de subItens
                      item.unidadeGestoraInfo.forEach((subItem) =>
                        effectiveByUnityArray.push([
                          FORMAT.capitalizeString(
                            subItem?.nmUnidadeGestora.toLowerCase()
                          ),
                          subItem?.informaoAnoMeses[0]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[0]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[1]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[1]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[2]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[2]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[3]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[3]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[4]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[4]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[5]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[5]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[6]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[6]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[7]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[7]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[8]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[8]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[9]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[9]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[10]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[10]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[11]?.info?.horaNormal?.toLocaleString(
                            'pt-br'
                          ),
                          subItem?.informaoAnoMeses[11]?.info?.horaExtra?.toLocaleString(
                            'pt-br'
                          )
                        ])
                      )
                      !reportHntHeByUnit.items[index + 1] && effectiveByUnityArray.push([
                        "Total",
                        reportHntHeByUnit?.total[0]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[0]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[1]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[1]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[2]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[2]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[3]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[3]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[4]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[4]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[5]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[5]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[6]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[6]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[7]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[7]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[8]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[8]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[9]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[9]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[10]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[10]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[11]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[11]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[12]?.info?.horaNormal?.toLocaleString(
                          'pt-br'
                        ),
                        reportHntHeByUnit?.total[12]?.info?.horaExtra?.toLocaleString(
                          'pt-br'
                        ),
                      ])
                      return effectiveByUnityArray
                    })
                    : [],
          tableTitle: collapseTitle.tableTitle,
          titleCollapse: collapseTitle.collapseTitle
        })
      })

      if (pdfDataArray) {
        const pdfObject: IHandlePrintConsolidacaoEfetivo = {
          data: pdfDataArray,
          filename: `relatorio-consolidacao-hnt-he`
        }
        handlePrintHntHe(pdfObject)
      } else {
        showModal({
          hideButtonCancel: true,
          message: 'Não há efetivo cadastrado para este contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          error.mensagem ||
          error.message ||
          'Não foi possivel obter a lista de Efetivos deste contrato',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const HeaderEffectiveConsolidationTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
        <Col justifyContent="center" marginLeft={SPACING.spacing200}>
          <Span
            text="HORAS NORMAIS TRABALHADAS x HORAS EXTRAS"
            color={COLORS.blueFonts}
            fontSize="24px"
            fontWeight={FONTS.bold}
            textTransform="uppercase"
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          />
          <Span
            textAlign="center"
            fontWeight="bold"
            fontSize={TYPOGRAPHY.bodySize16}
            color={COLORS.blueFonts}
            text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          />
        </Col>
      </Row>
    </Card>
  )

  const getReportHntHe = async () => {
    setLoading('loading')
    try {
      const response = await ReportsConsolidationServices().GetHNomaisxHExtras(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )

      if (response.status !== 200) throw new Error(response.statusText)

      setCurrentYear(response.data.entity.area?.total?.find((info) => info.mes === 1).ano)

      setReportHntHeByArea(response.data.entity.area)
      setReportHntHeByCompany(response.data.entity.empresa)
      setReportHntHeByExecutive(response.data.entity.diretoria)
      setReportHntHeByUnit(response.data.entity.unidadeNegocio)

      setLoading('idle')
    } catch (error: any) {
      setMsgErro('Erro ao carregar dados do relatório, tente novamente!')
      setLoading('error')
    }
  }

  useEffect(() => {
    getReportHntHe()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <div id="pdfView">
        {isGeneratePDF ? (
          <HeaderEffectiveConsolidationTitle />
        ) : (
          <>
            <Row
              justifyContent="center"
              marginTop={SPACING.spacing15}
              marginBottom={SPACING.spacing5}
            >
              <Span
                text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
                textAlign="center"
                fontWeight="bold"
                fontSize={TYPOGRAPHY.bodySize16}
                color={COLORS.blueFonts}
                marginTop={SPACING.spacing15}
                marginBottom={SPACING.spacing5}
              />
            </Row>
            <Row justifyContent="flex-end">
              <ExcelIcon onClick={() => GenerateExcelHntHe()} />
              <PdfIcon onClick={handleClickPdfReport} />
            </Row>
          </>
        )}
        <Row marginBottom={SPACING.spacing30} />
        <SimpleCollapse
          title="Distribuição por Diretoria Executiva"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportHntHeByExecutive}
            titleHeader="Diretoria Executiva"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Empresas"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportHntHeByCompany}
            titleHeader="Empresa"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Área"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportHntHeByArea}
            titleHeader="Área"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Unidade de Negócio"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            currentYear={currentYear}
            tableData={reportHntHeByUnit}
            titleHeader="Unidade Negócio"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>
      </div>
    </Card>
  )
}

export default ReportHntHe
